export type SectionKey = 'Debug' | 'Clients' | 'Stats' | 'Account';

export const SECTION_SUBTABS: Record<SectionKey, string[]> = {
  Debug: ['Tools'],
  Clients: ['Add Client', 'Manage Clients', 'Recent Reports', 'Open Admins', 'Manage Flags', 'Manage Messages'],
  Stats: ['Usage', 'Scheduled', 'Aggregate', 'System', 'Data Export'],
  Account: ['Subscription', 'Account Settings', 'Assessment Options', 'Touchpoints', 'Manage Team', 'Manage Accounts'],
};

export const PROD_SECTIONS: SectionKey[] = ['Clients', 'Stats', 'Account'];
export const DEV_SECTIONS: SectionKey[] = ['Debug', 'Clients', 'Stats', 'Account'];

export function resolveVisibleSections(showDebug: boolean): SectionKey[] {
  return showDebug ? DEV_SECTIONS : PROD_SECTIONS;
}

export function resolveInitialSection(
  initialTab: string | undefined,
  visibleSections?: SectionKey[]
): SectionKey {
  if (initialTab === 'Stats' || initialTab === 'Account') {
    // Only use requested tab if it's visible
    if (!visibleSections || visibleSections.includes(initialTab)) {
      return initialTab;
    }
  }
  
  // Default: use first visible section, fallback to 'Clients' if none provided
  if (visibleSections && visibleSections.length > 0) {
    // Prefer non-Debug sections
    const nonDebug = visibleSections.find(s => s !== 'Debug');
    return nonDebug || visibleSections[0];
  }
  
  return 'Clients';
}

export function resolveSubsection(section: SectionKey, requested: string): string {
  const tabs = SECTION_SUBTABS[section];
  return tabs.includes(requested) ? requested : tabs[0];
}
